import { transientOptions } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

export const BadgeWrapper = styled.span`
  flex-shrink: 0;
`

interface LabelWrapperProps {
  $wrap: boolean
}

export const LabelWrapper = styled('div', transientOptions)<LabelWrapperProps>`
  min-width: 0;

  ${({ $wrap }) =>
    $wrap &&
    css`
      & p {
        word-break: normal;
        overflow-wrap: anywhere;
      }
    `}
`
